import styled from 'styled-components';
import Hero from './components/Hero';
import PartnersScroll from '../Pricing/Scroll';
import YoutubeVideo from './components/YoutubeVideo';
import Form from './components/Form';
import ScrollRestore from '../../components/ScrollRestore';
import { PHONE_MEDIA_QUERY } from '../../common/responsive';

const TruestedByContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 60px;
  padding-bottom: 30px;
  gap: 60px;
  @media ${PHONE_MEDIA_QUERY} {
    padding-bottom: 0px;
  }
`;

const TruestedByText = styled.h3`
  font-size: 1.2rem;
  font-weight: 500;
`;

const Physical = () => {
  return (
    <div>
      <ScrollRestore />
      <Hero />
      <TruestedByContainer>
        <PartnersScroll />
      </TruestedByContainer>
      <YoutubeVideo />
      <Form />
    </div>
  );
};

export default Physical;
